import { ApiSlugs, UserDto, UserId } from '@workspace/data-types';
import { ApiCaller } from '../../api-caller.service';
import { ApiConnector } from '../../api-connector.abstract-service';

export class UsersConnector extends ApiConnector<UserDto, UserDto, UserId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.USERS);
  }
}
